import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=01e39eff&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=01e39eff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e39eff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01e39eff')) {
      api.createRecord('01e39eff', component.options)
    } else {
      api.reload('01e39eff', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=01e39eff&scoped=true&", function () {
      api.rerender('01e39eff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8bYpL9Coyj52H/JS/comp/SearchFilterTokens.vue"
export default component.exports